export const POST_CONTACT_US_REQUEST = 'contactUsReducer/POST_CONTACT_US_REQUEST';
export const POST_CONTACT_US_SUCCESS = 'contactUsReducer/POST_CONTACT_US_SUCCESS';
export const POST_CONTACT_US_FAILED = 'contactUsReducer/POST_CONTACT_US_FAILED';
